import { render, staticRenderFns } from "./DataTableDocumentosInscripciones.vue?vue&type=template&id=6dfd475e"
import script from "./DataTableDocumentosInscripciones.vue?vue&type=script&lang=js"
export * from "./DataTableDocumentosInscripciones.vue?vue&type=script&lang=js"
import style0 from "./DataTableDocumentosInscripciones.vue?vue&type=style&index=0&id=6dfd475e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports